/**
 * Converte uma URL pública de YouTube, Vimeo ou Instagram em URL de embed.
 * Retorna null se a URL não for reconhecida.
 *
 * YouTube suportado:
 *   https://www.youtube.com/watch?v=VIDEO_ID
 *   https://youtu.be/VIDEO_ID
 *   https://www.youtube.com/shorts/VIDEO_ID
 *
 * Vimeo suportado:
 *   https://vimeo.com/VIDEO_ID
 *
 * Instagram suportado:
 *   https://www.instagram.com/p/SHORTCODE/
 *   https://www.instagram.com/reel/SHORTCODE/
 */
export function getVideoEmbedUrl(url: string): string | null {
  if (!url) return null;

  const trimmed = url.trim();

  // YouTube — watch?v=
  const ytWatch = trimmed.match(
    /(?:youtube\.com\/watch\?.*v=)([a-zA-Z0-9_-]{11})/
  );
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}?rel=0`;

  // YouTube — youtu.be/
  const ytShort = trimmed.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}?rel=0`;

  // YouTube — /shorts/
  const ytShortsUrl = trimmed.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
  if (ytShortsUrl) return `https://www.youtube.com/embed/${ytShortsUrl[1]}?rel=0`;

  // Vimeo
  const vimeo = trimmed.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  // Instagram — post (/p/) ou reel (/reel/)
  const igPost = trimmed.match(/instagram\.com\/(p|reel)\/([a-zA-Z0-9_-]+)/);
  if (igPost) return `https://www.instagram.com/${igPost[1]}/${igPost[2]}/embed/`;

  return null;
}

/** Detecta a plataforma para exibir label no admin */
export function getVideoPlatform(url: string): 'youtube' | 'vimeo' | 'instagram' | null {
  if (!url) return null;
  if (/youtube\.com|youtu\.be/.test(url)) return 'youtube';
  if (/vimeo\.com/.test(url)) return 'vimeo';
  if (/instagram\.com/.test(url)) return 'instagram';
  return null;
}
